export default function Values() {
  const values = [
    {
      icon: 'ri-shield-star-line',
      title: 'Excellence',
      description: 'Nous nous engageons à fournir des services de la plus haute qualité avec des résultats garantis et durables'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Sécurité',
      description: 'La sécurité de nos clients et de l\'environnement est notre priorité absolue dans chaque intervention'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Respect de l\'Environnement',
      description: 'Utilisation de produits écologiques et de méthodes respectueuses de la nature et de la biodiversité'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Écoute Client',
      description: 'Une approche personnalisée et un accompagnement sur mesure pour répondre à vos besoins spécifiques'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Innovation',
      description: 'Adoption des dernières technologies et techniques pour une efficacité maximale dans nos interventions'
    },
    {
      icon: 'ri-medal-line',
      title: 'Professionnalisme',
      description: 'Une équipe certifiée et expérimentée qui respecte les normes les plus strictes du secteur'
    }
  ];

  return (
    <section id="valeurs" className="py-24 bg-gradient-to-br from-brand-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos Valeurs
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Des principes fondamentaux qui guident notre action quotidienne et notre engagement envers nos clients
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-brand-500 to-brand-700 rounded-xl flex items-center justify-center mb-6">
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}